import { controller, target } from "@github/catalyst"

// Keeps the scan box focused so a keyboard-wedge barcode scanner always types
// into it: focused on connect (including after Turbo re-renders the page) and
// whenever focus lands on nothing else interactive.
@controller
class ScanInputElement extends HTMLElement {
  @target input!: HTMLInputElement

  private onClick = (event: MouseEvent) => {
    const target = event.target
    if (target instanceof Element && target.closest("a, button, input, select, textarea, [contenteditable]")) return
    this.input.focus()
  }

  connectedCallback() {
    this.input.focus()
    document.addEventListener("click", this.onClick)
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onClick)
  }
}

export default ScanInputElement
